var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{attrs:{"title":_vm.$t('product.bulk_publish.title'),"bordered":false}},[_c('p',{staticClass:"mt-4"},[_vm._v(" "+_vm._s(_vm.$t('product.bulk_publish.easy_way_desc'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }